import PropTypes from 'prop-types';
import React from 'react';
// components
import EmployerLogo from './EmployerLogo/EmployerLogo';
// style
import './ParticipatingEmployersGrid.scss';

export default class ParticipatingEmployersGrid extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        attendingEmployers: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    static defaultProps = {};

    mapEmployerLogos = () => {
        const { attendingEmployers } = this.props;

        return attendingEmployers.map((employer) => (
            <EmployerLogo
                companyId={employer.companyId}
                image={employer.image}
                companyUrl={employer.companyUrl}
                key={employer.key}
            />
        ));
    };
    render() {
        const { attendingEmployers } = this.props;
        if (!attendingEmployers || attendingEmployers.length === 0) return null;

        return (
            <div className="component-Events-ParticipatingEmployersGrid">
                <div className="section-title">Participating Employers</div>
                <div className="grid-container">{this.mapEmployerLogos()}</div>
            </div>
        );
    }
}
